import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './savebookLoader.css';

export const SavebookLoader = (props) => {
  const {
    lang,
    previewFinished,
  } = props;

  if (previewFinished !== 'saving') {
    return null;
  }
  return (
    <div className="saveBookLoader">
      <div className="center">
        <div className="sk-chasing-dots">
          <div className="sk-child sk-dot1" />
          <div className="sk-child sk-dot2" />
        </div>
        <p>{lang.save_in_progress}</p>
      </div>
    </div>
  );
};

SavebookLoader.defaultProps = {
  lang: {},
  previewFinished: '',
};

SavebookLoader.propTypes = {
  lang: PropTypes.object,
  previewFinished: PropTypes.string,
};


export default connect(state => ({
  previewFinished: state.editorUI.previewFinished,
}))(SavebookLoader);



// WEBPACK FOOTER //
// ./src/components/savebook-loader/savebookLoader.jsx